import { Model } from "@/models/base/model";

export class User extends Model {
  // プロパティは名前: 型
  name: string;
  url: string;

  // コストラクタ（省略可能）
  constructor(params: any = {}) {
    super(params);
    this.name = "User";
    this.url = "/cms/api/user";
  }
}
